import {globalErrorCondition} from "../../../Helpers/ErrorHelper";
import { SET_DATE_RANGE, SET_SEARCH_TEXT, SET_FILTER, CLEAR_ALL_FILTER_SETTINGS } from "./FilterStore";
import {ACTIVITY_PAGE, VISITORS_API_URL} from "../Visitors";


const SET_VISITORS_ARE_LOADING = 'locale/visitors/visitors/SET_VISITORS_ARE_LOADING';
const POPULATE_VISITOR_DATA = 'locale/visitors/visitors/POPULATE_VISITOR_DATE';
const UPDATE_TOTAL_RESULTS = 'locale/visitors/visitors/UPDATE_TOTAL_RESULTS';
const SET_PAGINATION = 'locale/visitors/visits/SET_PAGINATION';

export const setVisitorsAreLoading = (scope, isLoading) => ({
    type: `${scope}_${SET_VISITORS_ARE_LOADING}`,
    isLoading
})

export const setPagination = (scope, page, perPage) => ({
    type: `${scope}_${SET_PAGINATION}`,
    payload: {
        page: page,
        perPage: perPage
    }
})

export const populateVisitorData = (scope, payload) => ({
    type: `${scope}_${POPULATE_VISITOR_DATA}`,
    payload
})

export const updateTotalResults = (scope, count) => ({
    type: `${scope}_${UPDATE_TOTAL_RESULTS}`,
    count
})

export const initialState = {
    isLoading: true,

    page: 1,
    perPage: 25,
    totalResults: false,

    visitors: [],
    visits: [],
    users: [],
};

export const visitorsReducerFor = (page, scope) => {
    return (state = initialState, action) => {

        switch (action.type) {

            // Reset pagination whenever a filter action is changed
            case `${page}_${SET_DATE_RANGE}`:
            case `${page}_${SET_SEARCH_TEXT}`:
            case `${page}_${SET_FILTER}`:
            case `${page}_${CLEAR_ALL_FILTER_SETTINGS}`:
                return {
                    ...state,
                    page: 1
                }

            case `${scope}_${SET_VISITORS_ARE_LOADING}`: {
                return {
                    ...state,
                    isLoading: action.isLoading
                }
            }

            case `${scope}_${SET_PAGINATION}`: {
                return {
                    ...state,
                    page: action.payload.page ?? state.page,
                    perPage: action.payload.perPage ?? state.perPage
                }
            }

            case `${scope}_${POPULATE_VISITOR_DATA}`: {
                return {
                    ...state,
                    visits: {...action.payload.referencedVisits},
                    users: {...action.payload.referencedUsers},
                    visitors: [...action.payload.items],
                    totalResults: action.payload.totalRows ?? null,
                }
            }

            case `${scope}_${UPDATE_TOTAL_RESULTS}`: {
                return {
                    ...state,
                    totalResults: action.count,
                }
            }

            default:
                return state;
        }
    }
}

export const getVisitorTabCounts = (scope, action) => async (dispatch, getState) => {
    let state = getState();

    let {searchText, dateRangeStart, dateRangeEnd} = state.module['VISITORS'][ACTIVITY_PAGE].filters;

    let params = {
        ...(searchText && {searchText: searchText}),
        ...(dateRangeStart && {dateRangeStart: dateRangeStart}),
        ...(dateRangeEnd && {dateRangeEnd: dateRangeEnd})
    };

    try {
        const {data} = await axios.get(
            `${VISITORS_API_URL}visitors/counts/${scope}`,
            { params: params }
        );
        for (const scopeName of Object.keys(data.tabCounts)) {
            dispatch(updateTotalResults(scopeName, data.tabCounts[scopeName]));
        }
    } catch (error) {
        globalErrorCondition('getVisitorTabCounts - Error loading visitor log data', error);
    }
}

export const getVisitorsData = (scope) => async (dispatch, getState) => {
    let state = getState();
    let {page, perPage} = state.module['VISITORS'][ACTIVITY_PAGE][scope];
    let {dateRangeStart, dateRangeEnd, searchStatus, searchText} = state.module['VISITORS'][ACTIVITY_PAGE].filters;

    let params = {
        perPage: perPage,
        page: page,
        ...(dateRangeStart && {dateRangeStart: dateRangeStart}),
        ...(dateRangeEnd && {dateRangeEnd: dateRangeEnd}),
        ...(searchText && {searchText: searchText})
    };

    dispatch(setVisitorsAreLoading(scope, true));

    try {
        const {data} = await axios.get(
            `${VISITORS_API_URL}visitors?type=${scope}`,
            { params: params }
        );
        dispatch(populateVisitorData(scope, data));
        dispatch(getVisitorTabCounts(scope));
        dispatch(updateTotalResults(scope, data.totalRows));

    } catch (error) {
        globalErrorCondition('getVisitorsData - Error loading visitor log data', error);
    } finally {
        dispatch(setVisitorsAreLoading(scope, false))
    }
}
